import { useMemo } from 'react';

const QUESTION_TYPES = {
  ESSAY: 'essay',
  EMAIL: 'email',
  AUDIO: 'audio',
  TWO_MINT_AUDIO: 'twoMinAudio',
  AUDIOESSAY: 'audioEssay',
  AUDIO_TRUE_FALSE: 'audioTrueFalse',
  AUDIO_MULTI_CHOICE: 'audioMultipleChoice',
  AUDIO_TO_IMAGE: 'audioToImage',
  VIDEO: 'video',
};

const useCheckAudioAndWritten = ({ questions = [] }) => {
  const isAudioAndWritten = useMemo(() => {
    if (questions === undefined || questions === null || !Array.isArray(questions)) {
      return false;
    }
    const hasAudio = questions.some((question) =>
      [
        QUESTION_TYPES.AUDIO,
        QUESTION_TYPES.TWO_MINT_AUDIO,
        QUESTION_TYPES.AUDIOESSAY,
        QUESTION_TYPES.AUDIO_TRUE_FALSE,
        QUESTION_TYPES.AUDIO_MULTI_CHOICE,
        QUESTION_TYPES.AUDIO_TO_IMAGE,
        QUESTION_TYPES.VIDEO,
      ].includes(question?.type),
    );

    const hasWritten = questions.some((question) =>
      [QUESTION_TYPES.ESSAY, QUESTION_TYPES.EMAIL].includes(question?.type),
    );

    return hasAudio || hasWritten;
  }, [questions]);

  const isCheckAudioAndWritten = (questions: any[]) => {
    if (!Array.isArray(questions)) {
      return false;
    }
    const hasAudio = questions.some((question) =>
      [
        QUESTION_TYPES.AUDIO,
        QUESTION_TYPES.TWO_MINT_AUDIO,
        QUESTION_TYPES.AUDIOESSAY,
        QUESTION_TYPES.AUDIO_TRUE_FALSE,
        QUESTION_TYPES.AUDIO_MULTI_CHOICE,
        QUESTION_TYPES.AUDIO_TO_IMAGE,
        QUESTION_TYPES.VIDEO,
      ].includes(question?.type),
    );

    const hasWritten = questions.some((question) =>
      [QUESTION_TYPES.ESSAY, QUESTION_TYPES.EMAIL].includes(question?.type),
    );

    return hasAudio || hasWritten;
  };

  const isCheckAudiOrWritten = (questions: any[]) => {
    if (!Array.isArray(questions)) {
      return false;
    }
    const hasAudio = questions.some((question) =>
      [
        QUESTION_TYPES.AUDIO,
        QUESTION_TYPES.TWO_MINT_AUDIO,
        QUESTION_TYPES.AUDIOESSAY,
        QUESTION_TYPES.AUDIO_TRUE_FALSE,
        QUESTION_TYPES.AUDIO_MULTI_CHOICE,
        QUESTION_TYPES.AUDIO_TO_IMAGE,
        QUESTION_TYPES.VIDEO,
      ].includes(question?.type),
    );

    const hasWritten = questions.some((question) =>
      [QUESTION_TYPES.ESSAY, QUESTION_TYPES.EMAIL].includes(question?.type),
    );

    return { hasAudio, hasWritten };
  };

  return { isAudioAndWritten, isCheckAudioAndWritten, isCheckAudiOrWritten };
};

export default useCheckAudioAndWritten;
